
import SocialMedia from "./SocialMedia";

import Introduce from "./Introduce";
const Home = () => {


    return (
        <div className="mainPage">

            <Introduce/>
       
            <SocialMedia/>
        </div>

    )

}

export default Home;


